import { useState, useEffect } from "react";
import { CampaignOverviewService } from "../utils/api";

const useCampaignInfoEffect = cid => {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});

  useEffect(() => {
    if (!cid) {
      setInfo({});
      setLoading(false);
      return;
    }

    setLoading(true);

    CampaignOverviewService({ cid }).then(inf => {
      setInfo(inf);
      setLoading(false);
    });
  }, [cid]);

  return { info, loading };
};

export default useCampaignInfoEffect;
